module.exports = __webpack_public_path__ + "img/codesandbox.2629354a.svg";